export enum Flipper {
  scanAndPay = 'rt_scan_and_pay',
}
